import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as tz from 'dayjs/plugin/timezone';
import { EncryptionService } from '../services/encryption.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';

dayjs.extend(utc);
dayjs.extend(tz);
@Injectable()
export class SetInterceptorService implements HttpInterceptor {
  constructor(
    private _encryptionSerivce: EncryptionService,
    private translate: TranslateService,
    private _authservice: AuthService
  ) {
    // Todo
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleRequest(req: HttpRequest<unknown>) {
    const storageKey = localStorage.getItem(environment.storageKey);
    const token: string | null = storageKey ? storageKey : null;

    let authReq: any;
    const headers = {
      'Content-Type': 'application/json',
      authorization: token ? `Bearer ${token}` : '',
      timeZone: dayjs.tz.guess(),
      date: dayjs().valueOf().toString()
    };
    if (req.url.includes('Factory/resetPassword')) {
      this._authservice.resetToken.subscribe((res: string) => {
        headers.authorization = `Bearer ${res}`;
      });
    }

    // eslint-disable-next-line prefer-const
    authReq = req.clone({
      headers: new HttpHeaders({
        hash: this._encryptionSerivce.encryptHeaders(headers),
        deviceType: 'web',
        language: this.translate.currentLang || ''
      })
    });

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put'
    ) {
      if (req.url.includes('Upload/uploadFiles')) {
        // Do nothing
      } else {
        authReq['body'] = {
          hash: this._encryptionSerivce.encryptionPayload(
            JSON.stringify(authReq.body)
          )
        };
      }
    }

    return authReq;
  }
}
